import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Select, MenuItem } from 'WeployDesignLanguage/Select';
import formatCurrency from '../../../utils/Currency';

const StyledCouponWrapper = styled.div`
  margin-top: ${props => props.theme.spacing[2]};
`;

const StyledBoldInfoText = styled.p`
  ${props => props.theme.typography.subtitle1};
  color: ${props => props.theme.colors.text.primary};
`;

const CouponSelection = ({
  onSelect,
  selectedCouponId,
  coupons,
}) => (
  <StyledCouponWrapper>
    <StyledBoldInfoText>Add a coupon</StyledBoldInfoText>
    <Select
      label="Coupon"
      onChange={(event) => { onSelect(event.target.value, coupons); }}
      required
      value={selectedCouponId}
      width="250px"
    >
      <MenuItem value="">None</MenuItem>
      {
        coupons.map(({ code, id, remainingCredit }) => (
          <MenuItem key={id} value={id}>{`${code} (${formatCurrency(remainingCredit, 'AUD')})`}</MenuItem>
        ))
      }
    </Select>
  </StyledCouponWrapper>
);

CouponSelection.propTypes = {
  onSelect: PropTypes.func.isRequired,
  selectedCouponId: PropTypes.string,
  coupons: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    remainingCredit: PropTypes.number.isRequired,
  })).isRequired,
};

CouponSelection.defaultProps = {
  selectedCouponId: '',
};

export default CouponSelection;
